module.exports = __webpack_public_path__ + "static/img/2_13_2.4840f041.jpg";